import React from 'react';
import styled, { css } from 'styled-components';

import MQ from '@rover/kibble/styles/MediaQuery';

export const Wrapper = styled.div<{ pageIndicatorPosition: 'top' | 'bottom' }>`
  position: absolute;
  display: flex;
  align-items: center;
  height: 28px;
  ${(props) =>
    props.pageIndicatorPosition === 'top'
      ? css`
          top: 0;
          right: 0;
          padding-right: 16px;
          ${MQ.XS_DOWN.toString()} {
            display: none;
          }
        `
      : css`
          bottom: 0;
          right: 0;
          left: 0;
          width: 100%;
          justify-content: center;
        `};
`;

export const IndicatorDot = styled.div<{
  selected: boolean;
}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) =>
    props.selected ? props.theme.textColor.tertiary : props.theme.textColor.disabled};
  margin-left: 8px;
`;
export type Props = {
  pages: number;
  selectedPage: number;
  pageIndicatorPosition: 'top' | 'bottom';
};

const CarouselPageIndicator = ({ pages, selectedPage, ...other }: Props): JSX.Element => {
  const dots: JSX.Element[] = [];
  let i = 0;

  while (i < pages) {
    dots.push(<IndicatorDot selected={i === selectedPage} key={i} data-testid="indicator-dot" />);
    i += 1;
  }

  return (
    <Wrapper {...other} data-testid="styled-div">
      {dots}
    </Wrapper>
  );
};

export default CarouselPageIndicator;
